import { useAuth } from '@/hooks/useAuth';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { MessageCircle } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';

export const CoachPanelHeader = () => {
  const { user } = useAuth();

  const { data: lastAnalysis } = useQuery({
    queryKey: ['coach-panel-last', user?.id],
    queryFn: async () => {
      if (!user) return null;
      const { data } = await supabase
        .from('career_coach_analyses')
        .select('analysis_type, updated_at')
        .eq('user_id', user.id)
        .order('updated_at', { ascending: false })
        .limit(1)
        .maybeSingle();
      return data;
    },
    enabled: !!user,
    staleTime: 60 * 1000,
  });

  const typeLabels: Record<string, string> = {
    skill_gap: 'skill gaps',
    goal_suggestions: 'goal suggestions',
    progress_coaching: 'your progress',
    career_path_discovery: 'career paths',
    freetext_chat: 'your coaching chat',
  };

  return (
    <div className="flex items-center gap-3 px-4 pt-4 pb-2">
      <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
        <MessageCircle className="w-5 h-5 text-primary" />
      </div>
      <div className="min-w-0">
        <h3 className="font-semibold text-base">AI Coach</h3>
        {lastAnalysis ? (
          <p className="text-xs text-muted-foreground truncate">
            Last time: We discussed {typeLabels[lastAnalysis.analysis_type] || lastAnalysis.analysis_type}{' '}
            {formatDistanceToNow(new Date(lastAnalysis.updated_at), { addSuffix: true })}
          </p>
        ) : (
          <p className="text-xs text-muted-foreground">Ready to help with your career development</p>
        )}
      </div>
    </div>
  );
};
